export function getProcessedItemRowCount(item) {
  if (!item) return 0;
  if (Array.isArray(item.records) && item.records.length > 0) return item.records.length;
  if (item.savePayload?.rows && Array.isArray(item.savePayload.rows)) {
    return item.savePayload.rows.length;
  }
  if (Array.isArray(item.sheetSummaries)) {
    return item.sheetSummaries.reduce((sum, sheet) => sum + (sheet.rowCount || 0), 0);
  }
  return 0;
}

export function getSaveProgress(item) {
  const totalRows = getProcessedItemRowCount(item);
  const insertedRows = Number(item?.saveResult?.inserted_row_count ?? 0) || 0;
  const duplicateRows = Number(item?.saveResult?.duplicate_row_count ?? 0) || 0;
  const skippedRows = Number(item?.saveResult?.skipped_row_count ?? 0) || 0;
  const handledRows = insertedRows + duplicateRows + skippedRows;

  return {
    totalRows: totalRows || handledRows,
    insertedRows,
    duplicateRows,
    skippedRows,
  };
}

export function formatSaveProgress(item) {
  const { totalRows, insertedRows } = getSaveProgress(item);
  if (!totalRows) return null;
  return `${insertedRows}/${totalRows} rows saved`;
}
